<template>
  <div id="Header">
    <div class="navbar">
      <div class="navbar-inner">
        <div class="navbar-left">
          <!-- <a href="#" class="navbar-item active-logo">晓A精灵</a> -->
          <span class="navbar-item active-logo"></span>
          <span
            @click="headerClickHandle(item)"
            class="navbar-item"
            :class="{ active: $route.name == item.pathName }"
            v-for="item in headerData"
            :key="item.id"
            >{{ item.name }}</span
          >
        </div>
        <div class="navbar-right">
          <a class="navbar-item" @click="handleCommand('english')">学习中心</a>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <a class="navbar-item btn">管理中心</a>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="admin">后台管理中心</el-dropdown-item>
              <el-dropdown-item command="teacher"
                >教师管理中心</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
    <div class="footer">
      <div class="footer-inner">
        <div class="footer-col">
          <div class="footer-col-title title1">晓A精灵</div>
          精准发音，全球对话，你的AI英语专家。
          <div class="icon-box">
            <!-- <span class="icon"></span>
            <span class="icon"></span>
            <span class="icon"></span> -->
            <span class="code"></span>
          </div>
        </div>
        <div class="footer-col">
          <div class="footer-col-title">产品</div>
          下载
          <!-- <br />功能<br />价格 -->
        </div>
        <div class="footer-col">
          <div class="footer-col-title">公司</div>
          关于我们
          <!-- <br />新闻中心<br />加入我们 -->
        </div>
        <div class="footer-col">
          <div class="footer-col-title">支持</div>
          <!-- 用户分享 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      headerData: [
        {
          id: 1,
          name: "首页",
          pathName: "index",
        },
        {
          id: 2,
          name: "下载",
          pathName: "browserdownload",
        },
        // {
        //   id: 3,
        //   name: "用户分享",
        //   pathName: "share",
        // },
        {
          id: 4,
          name: "新闻中心",
          pathName: "news",
        },
        {
          id: 5,
          name: "合作咨询",
          pathName: "join",
        },
        {
          id: 6,
          name: "了解企业",
          pathName: "info",
        },
      ],
    };
  },
  methods: {
    headerClickHandle(item) {
      this.$router.push({
        name: item.pathName,
      });
    },
    handleCommand(name) {
      window.open(`https://www.xajlai.com/${name}/#/login`);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  background: #fff;
  border-bottom: 1px solid #e5eaf3;
  height: 60px;
  .navbar-inner {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    .navbar-left,
    .navbar-right {
      display: flex;
      align-items: center;
      .navbar-item {
        color: #9a212a;
        text-decoration: none;
        margin: 0 16px;
        font-size: 16px;
        cursor: pointer;
      }
      .active-logo {
        font-size: 18px;
        color: #9a212a;
        font-weight: bold;
        display: inline-block;
        width: 90px;
        height: 70px;
        background-image: url(../assets/new-page/hone/logo1.png);
        background-size: 100% 100%;
      }
      .navbar-item.active {
        position: relative;
        color: #9a212a;
        font-weight: bold;
        &::after {
          left: 0;
          bottom: -8px;
          height: 2px;
          background: #9a212a;
          border-radius: 2px;
          width: 100%;
          position: absolute;
          content: "";
        }
      }
    }
    .navbar-right {
      .navbar-item {
        color: #9a212a;
      }
      .btn {
        background: #9a212a;
        color: #fff;
        border-radius: 4px;
        padding: 6px 18px;
        margin-left: 16px;
        font-size: 15px;
        text-decoration: none;
      }
    }
  }
}
.footer {
  background: #9a212a;
  color: #fff;
  padding: 40px 0;
  // text-align: center;
  font-size: 15px;
  .footer-inner {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .footer-col {
      flex: 1;
      color: #bfc6d1;
      font-size: 14px;
      line-height: 2;
      .title1 {
        font-size: 20px;
      }
      .footer-col-title {
        color: #fff;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .icon-box {
        margin-top: 17px;
        display: flex;
        .code {
          width: 100px;
          height: 100px;
          background-image: url(../assets/new-page/hone/code.jpg);
          background-size: 100% 100%;
        }
        .icon {
          margin-right: 20px;
          width: 20px;
          height: 20px;
          border-radius: 20px;
          // background: pink;
        }
      }
    }
  }
}
</style>
